import type { GVariantBadgeProps } from '~/presentation/ui';

import { IVariantType } from '~/modules/campaign/types';

type VariantDataType = {
  tone: GVariantBadgeProps['tone'];
  variantType: IVariantType;
  description?: string;
};
export const variantDataMapping: Record<IVariantType, VariantDataType> = {
  [IVariantType.VARIANT_A]: {
    tone: 'active',
    variantType: IVariantType.VARIANT_A,
  },
  [IVariantType.VARIANT_B]: {
    tone: 'inactive',
    variantType: IVariantType.VARIANT_B,
    description: 'Choosing this option will override Control A with Variant B.',
  },
};
